import React from 'react';
import { Checkbox } from 'mintel-react-ui';

export interface CheckboxWrapperProps {
  name: string;
  checked: boolean; // intentionally excluding 'mixed' option from MRUI checkbox
  onChange: () => void;
  label: string | JSX.Element;
  id: string;
}

export const CheckboxWrapper = ({
  name,
  checked,
  onChange,
  label,
  id,
  ...checkboxProps
}: CheckboxWrapperProps): JSX.Element => (
  <>
    <input
      hidden
      name={name}
      type="checkbox"
      checked={checked}
      id={id}
      data-testid="formCheckbox"
      onChange={() => {
        /* readonly to get rid of console warning */
      }}
    />
    <Checkbox
      {...checkboxProps}
      checked={checked}
      onChange={onChange}
      label={label}
      id={id}
    />
  </>
);

export default CheckboxWrapper;
